module.exports = "/dist/images/9843decbf6e00dd46bbf18f54258acdf-devices.jpg";